import React from "react";
import { Helmet } from "react-helmet-async";
import { Box } from "@mui/material";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";
import { INK } from "../theme/brand";
import Hero from "./landing/Hero";
import NewFeature from "./landing/NewFeature";
import Highlights from "./landing/Highlights";
import MobileShowcase from "./landing/MobileShowcase";
import AllFeatures from "./landing/AllFeatures";
import Steps from "./landing/Steps";
import Pricing from "./landing/Pricing";
import Faq from "./landing/Faq";
import CtaBand from "./landing/CtaBand";
import { FAQ_ITEMS } from "./landing/content";

export default function LandingPage() {
  return (
    <Box sx={{ bgcolor: "#fff", color: "grey.900" }}>
      <Helmet>
        <title>MartialVerse – Software für Kampfsportschulen</title>
        {/* iOS/Safari: Overscroll oben weiß (Header), unten dunkel (Footer) */}
        <style>{`html { background: linear-gradient(to bottom, #ffffff 50%, ${INK} 50%); }`}</style>
        <meta
          name="description"
          content="MartialVerse ist die Verwaltungssoftware für Kampfsportschulen: Mitgliederverwaltung, direkte digitale Beitragsabbuchung ohne SEPA-Datei, Gürtelprüfungen und Rechnungen in einer Anwendung. 1 Monat kostenlos testen."
        />
        <link rel="canonical" href="https://www.martialverse.de/" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            name: "MartialVerse",
            applicationCategory: "BusinessApplication",
            operatingSystem: "Web",
            description:
              "Verwaltungssoftware für Kampfsportschulen: Mitgliederverwaltung, direkte digitale Beitragsabbuchung ohne SEPA-Datei, Gürtelprüfungen und Rechnungen.",
            url: "https://www.martialverse.de/",
            inLanguage: "de",
            offers: {
              "@type": "AggregateOffer",
              priceCurrency: "EUR",
              lowPrice: "19.00",
              highPrice: "75.00",
              offerCount: 5,
              description:
                "Staffelpreise nach Mitgliederzahl, zzgl. 19 % MwSt., 1 Monat kostenlose Testphase",
            },
            publisher: {
              "@type": "Organization",
              name: "Softabit – MartialVerse",
              url: "https://www.martialverse.de/",
              address: {
                "@type": "PostalAddress",
                streetAddress: "Karwendelstraße 126",
                postalCode: "86163",
                addressLocality: "Augsburg",
                addressCountry: "DE",
              },
            },
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: FAQ_ITEMS.map((item) => ({
              "@type": "Question",
              name: item.q,
              acceptedAnswer: {
                "@type": "Answer",
                text: item.a,
              },
            })),
          })}
        </script>
      </Helmet>

      <SiteHeader />
      <main>
        <Hero />
        <NewFeature />
        <Highlights />
        <MobileShowcase />
        <AllFeatures />
        <Steps />
        <Pricing />
        <Faq />
        <CtaBand />
      </main>
      <SiteFooter />
    </Box>
  );
}
